import ReactDOM from 'react-dom/client';
import { App } from './App.tsx';
import './index.scss';
import { Provider } from 'react-redux';
import { store } from '@state/dynamic-store';
import { AuthProvider } from '@auth/AuthProvider';
import { ThemeProvider } from '@mui/material/styles';
import { PermissionProvider } from '@auth/PermissionProvider';
import brzTheme from '@brz/brz-global-mui-theme';
import { SnackbarProvider } from '@utils/snackbar/SnackbarContext';
import { initializeMsalInstance } from '@auth/msal-instance';
import { initializeAnalytics } from '@analytics/analytics';
import {
    RowAutoHeightModule,
    PaginationModule,
    TooltipModule,
    QuickFilterModule,
    TextEditorModule,
    LargeTextEditorModule,
    SelectEditorModule,
    NumberEditorModule,
    DateEditorModule,
    CheckboxEditorModule,
    LocaleModule,
    CsvExportModule,
    ValidationModule,
    RenderApiModule,
    ColumnApiModule,
    EventApiModule,
    ClientSideRowModelModule,
    CellStyleModule,
    CustomEditorModule,
    RowApiModule,
    ScrollApiModule,
    RowSelectionModule
} from 'ag-grid-community';
import {
    LicenseManager,
    ModuleRegistry,
    RichSelectModule,
    SideBarModule,
    ColumnsToolPanelModule,
    FiltersToolPanelModule,
    ColumnMenuModule,
    ContextMenuModule,
    ExcelExportModule,
    ClipboardModule,
    ServerSideRowModelModule,
    ServerSideRowModelApiModule,
    SetFilterModule
} from 'ag-grid-enterprise';

ModuleRegistry.registerModules([
  RowAutoHeightModule,
  PaginationModule,
  TooltipModule,
  QuickFilterModule,
  TextEditorModule,
  LargeTextEditorModule,
  SelectEditorModule,
  NumberEditorModule,
  DateEditorModule,
  CheckboxEditorModule,
  LocaleModule,
  CsvExportModule,
  RichSelectModule,
  SideBarModule,
  ColumnsToolPanelModule,
  FiltersToolPanelModule,
  ColumnMenuModule,
  ContextMenuModule,
  ExcelExportModule,
  ClipboardModule,
  ServerSideRowModelModule,
  ValidationModule,
  RenderApiModule,
  ColumnApiModule,
  ServerSideRowModelApiModule,
  EventApiModule,
  ClientSideRowModelModule,
  SetFilterModule,
  CellStyleModule,
  CustomEditorModule,
  RowApiModule,
  ScrollApiModule,
  RowSelectionModule
]);

LicenseManager.setLicenseKey(import.meta.env.VITE_AG_GRID_LICENSE_KEY);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const renderApp = async () => {
  // Initialize MSAL instance
  await initializeMsalInstance();
  initializeAnalytics();

  root.render(
    <Provider store={store}>
      <AuthProvider>
        <PermissionProvider>
          <ThemeProvider theme={brzTheme}>
            <SnackbarProvider>
              <App />
            </SnackbarProvider>
          </ThemeProvider>
        </PermissionProvider>
      </AuthProvider>
    </Provider>
  );
};

renderApp();
